var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "q-form",
        { ref: "editForm" },
        [
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { noHeader: true, topClass: "topcolor-blue" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-6" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.param.editables,
                        label: "취급물질",
                        name: "inMaterials",
                      },
                      model: {
                        value: _vm.item.inMaterials,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "inMaterials", $$v)
                        },
                        expression: "item.inMaterials",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.param.editables,
                        label: "물질상태",
                        name: "volume",
                      },
                      model: {
                        value: _vm.item.volume,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "volume", $$v)
                        },
                        expression: "item.volume",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.param.editables,
                        label: "연결구정보",
                        name: "calculateThick",
                      },
                      model: {
                        value: _vm.item.calculateThick,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "calculateThick", $$v)
                        },
                        expression: "item.calculateThick",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        suffix: "MPa",
                        editable: _vm.param.editables,
                        label: "압력(MPa)-설계",
                        name: "pressDesign",
                      },
                      model: {
                        value: _vm.item.pressDesign,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "pressDesign", $$v)
                        },
                        expression: "item.pressDesign",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        suffix: "MPa",
                        editable: _vm.param.editables,
                        label: "압력(MPa)-운전",
                        name: "pressOperation",
                      },
                      model: {
                        value: _vm.item.pressOperation,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "pressOperation", $$v)
                        },
                        expression: "item.pressOperation",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        suffix: "℃",
                        editable: _vm.param.editables,
                        label: "온도(℃)-설계",
                        name: "tempDesign",
                      },
                      model: {
                        value: _vm.item.tempDesign,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "tempDesign", $$v)
                        },
                        expression: "item.tempDesign",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        suffix: "℃",
                        editable: _vm.param.editables,
                        label: "온도(℃)-운전",
                        name: "tempOperation",
                      },
                      model: {
                        value: _vm.item.tempOperation,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "tempOperation", $$v)
                        },
                        expression: "item.tempOperation",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
          _c(
            "c-card",
            {
              staticClass: "cardClassDetailForm",
              attrs: { noHeader: true, topClass: "topcolor-blue" },
            },
            [
              _c("template", { slot: "card-detail" }, [
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        suffix: "㎥",
                        editable: _vm.param.editables,
                        label: "용량(㎥)-설계",
                        name: "nondestructPercent",
                      },
                      model: {
                        value: _vm.item.nondestructPercent,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "nondestructPercent", $$v)
                        },
                        expression: "item.nondestructPercent",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        suffix: "㎥",
                        editable: _vm.param.editables,
                        label: "용량(㎥)-운전",
                        name: "corrosionAllowance",
                      },
                      model: {
                        value: _vm.item.corrosionAllowance,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "corrosionAllowance", $$v)
                        },
                        expression: "item.corrosionAllowance",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.param.editables,
                        label: "사용재질",
                        name: "materialMain",
                      },
                      model: {
                        value: _vm.item.materialMain,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "materialMain", $$v)
                        },
                        expression: "item.materialMain",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-3" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.param.editables,
                        label: "설계표준",
                        name: "weldingEfficiency",
                      },
                      model: {
                        value: _vm.item.weldingEfficiency,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "weldingEfficiency", $$v)
                        },
                        expression: "item.weldingEfficiency",
                      },
                    }),
                  ],
                  1
                ),
                _c(
                  "div",
                  { staticClass: "col-12" },
                  [
                    _c("c-text", {
                      attrs: {
                        editable: _vm.param.editables,
                        label: "비고",
                        name: "applicableLaws",
                      },
                      model: {
                        value: _vm.item.applicableLaws,
                        callback: function ($$v) {
                          _vm.$set(_vm.item, "applicableLaws", $$v)
                        },
                        expression: "item.applicableLaws",
                      },
                    }),
                  ],
                  1
                ),
              ]),
            ],
            2
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }